import type { PlatformsContent, SearchContent } from "../types";

export const platforms: PlatformsContent = {
  meta: {
    // [de-review] SERP-visible; pinned to the 60/160 caps by seo.test.tsx.
    title: "MetaTrader 5 Prop-Firm-Plattform | Flex Fund",
    description:
      "Live MetaTrader 5 mit Raw Spreads, Tier-1-Liquidität und 12 ms Median-Ausführung — die Plattform, die ein ernsthafter Prop-Trader erwartet.",
  },
  hero: {
    builtOn: "Gebaut auf ",
    // PROPER NOUN — the product name. Identical in every locale.
    product: "MetaTrader 5",
    tail: ".",
    line2: "Gebaut auf Tempo.",
    // [de-review] Repeats the latency and liquidity claims.
    lede: "Live MT5, Raw Spreads, Tier-1-Liquidität. 12 ms Median-Ausführung. Dieselbe Plattform, dieselben Daten, die dein Prop-Desk nutzt.",
    ctaSecondary: "Instrumente ansehen",
  },
  stats: {
    latency: "Median-Ausführungslatenz",
    // "EUR/USD" is an instrument pair and stays identical.
    spread: "Durchschn. Pip-Spread, EUR/USD",
    uptime: "Verfügbarkeit · 90 Tage",
    liquidity: "Prime-Liquidität",
  },
  why: {
    titleLead: "Die Plattform, auf die ",
    titleHighlight: "professionelle Trader",
    titleTail: " setzen.",
  },
  features: {
    algoTrading: {
      title: "Algo-Trading",
      desc: "Expert Advisors und eigene Indikatoren ausführen. MQL5- und Python-Bridges werden unterstützt.",
    },
    depthOfMarket: {
      title: "Markttiefe",
      desc: "Echtes DOM mit vollständig sichtbarem Orderbuch. Plus Time-&-Sales-Feed für jedes Symbol.",
    },
    oneClick: {
      title: "One-Click-Trading",
      desc: "Ausführung aus Chart, DOM oder Watchlist. Hotkeys + Drag-to-Modify.",
    },
    mobileDesktop: {
      title: "Mobil + Desktop",
      // Operating-system names are proper nouns and stay identical.
      desc: "Dasselbe Konto auf Windows, macOS, iOS, Android. Der Status synchronisiert in Echtzeit.",
    },
    strategyTester: {
      title: "Strategie-Tester",
      desc: "Backtests mit Tick-Daten über mehr als 10 Jahre.",
    },
    multiAccount: {
      title: "Multi-Konto",
      // [de-review] States how many funded accounts may run at once.
      desc: "Bis zu 5 finanzierte Konten parallel aus einem Terminal betreiben.",
    },
  },
  faq: {
    titleLead: "Fragen zu Ausführung ",
    titleHighlight: "und Plattform",
    titleTail: ".",
    sub: "Durchsuche die vollständige Bibliothek in der Flex Fund Wissensdatenbank. Tiefere Antworten, mehr Detail.",
    browseAll: "Alle FAQs ansehen",
    items: {
      whichPlatforms: { q: "Welche Handelsplattformen bietet Flex Fund an?", category: "PLATTFORM" },
      liquidityExecution: { q: "Wer stellt Liquidität und Ausführung bereit?", category: "AUSFÜHRUNG" },
      leverage: { q: "Welcher Hebel wird angeboten?", category: "REGELN" },
      easBots: { q: "Darf ich Expert Advisors (EAs) oder Bots nutzen?", category: "PLATTFORM" },
    },
  },
};

export const search: SearchContent = {
  meta: {
    title: "Suche — Flex Fund",
    description: "Flex Fund durchsuchen — Prop Firm, MetaTrader-5-Plattform, FAQ und mehr.",
  },
  heading: "Flex Fund durchsuchen",
  redirecting: "Weiterleitung zu den Flex Fund Suchergebnissen…",
};
